export default "__VITE_ASSET__B815X_JZ__"